import { AddBalanceMainAccount, ExpenseCard } from "~/application/types";
import { AddBalanceMainAccountDTO, ExpenseCardDTO } from "../dtos";

export function mapExpenseCardDTO(dto: ExpenseCardDTO): ExpenseCard {
  return {
    id: dto.uuid,
    number: dto.number,
    securityCode: dto.security_code,
    lastFourNumbers: dto.last_four_numbers,
    type: dto.type,
    balance: dto.balance,
    status: dto.status,
    description: dto.description,
    validity: dto.validity,
    owner: {
      id: dto.owner.uuid,
      name: dto.owner.name,
      cpf: dto.owner.cpf,
    },
    virtualCards: dto.virtual_cards
      ? dto.virtual_cards.map((virtualCard) =>
          mapExpenseCardDTO({
            ...virtualCard,
            owner: dto.owner,
          }),
        )
      : undefined,
  };
}

export function mapAddBalanceMainAccountDTO(dto: AddBalanceMainAccountDTO): AddBalanceMainAccount {
  return {
    amount: dto.amount,
    orderId: dto.order_id,
    type: dto.type,
    qrCodeData: dto.qr_code_data,
  };
}
